import { render, staticRenderFns } from "./blockTextSettings.vue?vue&type=template&id=202c106a&scoped=true&"
import script from "./blockTextSettings.vue?vue&type=script&lang=js&"
export * from "./blockTextSettings.vue?vue&type=script&lang=js&"
import style0 from "./blockTextSettings.vue?vue&type=style&index=0&id=202c106a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c106a",
  null
  
)

export default component.exports